module.exports = __webpack_public_path__ + "img/Volvox_carteri.c2a3c581.jpg";